<template>
    <div id="">
        <flash-message></flash-message>
        <div class="text-followup-nav mb-5">
            <div v-if="project" class="text-2xl text-grey-darkest mb-4">Project Resources for {{projectName ? projectName : ''}}</div>
            <div v-else class="text-2xl text-grey-darkest mb-4">Resources</div>
            <div v-if="this.project" class="text-teal hover:text-teal-dark font-base text-sm mb-4">
                <div @click="goBack" class="flex cursor-pointer">
                    <span class="material-icons">chevron_left</span>
                    <span>Back</span>
                </div>
            </div>
            </div>
        <div>
            <div v-if="stack" @click.stop.prevent="uploadToStack()" class="pointer hover:bg-grey-lighter mx-1 change_text_color">
                Upload to STACK <i class="fa fa-upload pl-2"></i>
            </div>
        </div>

        <ejs-filemanager
            id="file-manager"
            :hasId="hasId"
            :key="resourceFiles.id_key"
            :allowDragAndDrop="allowDragAndDrop"
            :fileDragStart="onFileDragStart"
            :fileDragStop="onFileDragStop"
            :fileDragging="onFileDragging"
            :fileDropped="onFileDropped"
            :ajaxSettings="ajaxSettings"
            @beforeSend="beforeSend($event)"
            :success= "onAjaxSuccess"
            :showThumbnail="true"
            @load="finishLoadThumbnail(resourceFile)"
            :failure="onAjaxFailure"
            :toolbarSettings="toolbarSettings"
            :contextMenuSettings="contextMenuSettings"
            :uploadSettings="uploadSettings"
        >
        </ejs-filemanager>
    </div>
</template>

<script>
import { DetailsView, NavigationPane, Toolbar } from "@syncfusion/ej2-vue-filemanager";
import axios from "axios";
import Form from "../../utils/form";
const baseUrl = window.location.origin;
export default {
    name: "resource-files-new",
    props: ['folders', 'team_id', 'user_id', 'clean', 'project', 'isPm', 'stack', 'companyCam', 'folder', 'projectName'],
    data() {
        return {
            hasId:true,
            displayType: 'grid',
            updateResourceFile: {},
            resourceFiles: [],
            revertedResources: [],
            data_loading: false,
            hasOneFile: false,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            server: {
                revert: (uniqueFileId, load, error) => {
                    let file = JSON.parse(uniqueFileId).resource;
                    this.revertedResources.push(file.token);
                    axios.delete(route('api.resource-files.destroy', {resourceFile: file.token}))
                        .catch((err) => error(err.response.message));
                    load();
                },
                process: (fieldName, file, metadata, load, error, progress) => {
                    const formData = new FormData();
                    if (this.company) formData.append('company_id', this.company);
                    if (this.project) formData.append('project_id', this.project);
                    if (this.folder) formData.append('directory_id', this.folder.id);
                    formData.append(fieldName, file, file.name);
                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/resource-files');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };
                    request.send(formData);
                }
            },
            form: new Form({
                folder_id: this.folder ? this.folder.id : null,
                resource_id: null,
            }),
            allowDragAndDrop: true,
            enablePersistence: true,
            ajaxSettings:
                {
                    url: this.project ? baseUrl+"/api/get-resource-files/team/"+this.team_id+"/project/"+this.project : baseUrl+"/api/get-resource-files/"+this.team_id,
                    getImageUrl: baseUrl+"/api/get-image",
                    uploadUrl: this.project ? baseUrl+"/api/upload-resource-files/user/"+this.user_id+"/project/"+this.project : baseUrl+"/api/upload-resource-files/"+this.user_id,
                    downloadUrl: this.project ? baseUrl+"/api/download-files/team/"+this.team_id+"/project/"+this.project : baseUrl+"/api/download-files/"+this.team_id,
                },
            // view:'details',
            toolbarSettings: { items: ['Upload', 'Download', 'Delete', 'Refresh', 'View', 'SelectAll', 'Rename','NewFolder'], visible: true},
            contextMenuSettings: { file: ['Open', 'Download'],
                    folder: ['Open'],
                    layout: ['Refresh', '|', 'Upload', '|', 'SelectAll'],
                    visible: true},
            uploadSettings: { minFileSize: 0, maxFileSize: 5e+8}
        };
    },
    provide: {
        filemanager: [DetailsView, NavigationPane, Toolbar]
    },
    created() {
        this.fetchData();
    },
    methods:{
        fetchData() {
            let params = {
                filter: this.filter,
                page: this.page,
                company_id: this.company,
                project_id: this.project,
                folder_id: this.folder ? this.folder.id : null,
            };
            this.data_loading = true;
            axios.get(route('api.resource-files.index'), {params}).then(({data}) => {
                this.resourceFiles = data.data.map(resourceFile => {
                    resourceFile.thumb_url = route('resource-files.show-thumb', {resourceFile: resourceFile.token});
                    resourceFile.is_thumb_loaded = false;
                    resourceFile.id_key = resourceFile.id;
                    return resourceFile;
                });
                this.hasOneFile = this.resourceFiles.length > 0;
                this.pagination = data;
                this.data_loading = false;
            });
        },
        // File Manager's file Drag start event function
        onFileDragStart: function(args){
            // console.log("File Drag Start 1", args);
        },
        // File Manager's file Drag stop event function
        onFileDragStop: function(args){
            // console.log("File Drag Stop 1", args);
        },
        // File Manager's file Dragging event function
        onFileDragging: function(args){
            // console.log("File Dragging 1", args);
        },
        // File Manager's file Dropped event function
        onFileDropped: function(args){
            // console.log("File Dropped 1", args);
        },
        // File Manager's file Dropped event function
        sendDataToServer: function(args){
            // this.ajaxSettings.getImageUrl = args.fileDetails[0].targetPath
            //
            // console.log("this.ajaxSettings.getImageUrl", this.ajaxSettings.getImageUrl);
        },
        beforeSend(args){
            args.ajaxSettings.beforeSend = function (args) {
                //Setting authorization header
                //  console.log('inside',args)
            }
            // args.setRequestHeader("Authorization","Bearer" + token);
        },
        finishLoadThumbnail(resourceFile) {
            console.log(resourceFile)
            if (!resourceFile.is_thumb_loaded) {
                resourceFile.is_thumb_loaded = true;
                resourceFile.id_key += 'a';
            }
        },
        onAjaxSuccess(args){
            console.log("Ajax request successful");
            this.ajaxSettings.getImageUrl = "https://dev-followupcrm.s3.us-east-2.amazonaws.com/thum_photo/resources_17LLdNLj3cy0ANGHNMHhP8Z89FJZinpVyoPsrMoI.jpg"
        },
        // File Manager's file onError function
        onAjaxFailure(args){
            console.log("Ajax request has failed", args);
        },
        onUploadSuccess: function (args) {
            console.log('Uploaded successfully',args);
            /*   args.ajaxSettings.beforeSend = function (args) {
                   //Setting authorization header
                    console.log('inside',args)
               }*/
        },
        goBack() {
            window.location = route(`${this.isPm ? 'project-management.' : ''}project.edit`, {project: this.project});
        },
        async uploadToStack(){
            const self = this;
            await axios.post(route('resource-files.upload-stack'),{
                project_id: this.project,
                // folder_id: this.folder.id
            }).then((res) =>{
                self.flash(res.data.message, res.data.status);
            }).catch((err)=>{
                console.log('err',err)
            })
        },
    }
}
</script>

<style scoped>
/*
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-icons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-popups/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-layouts/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-grids/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-filemanager/styles/material.css";
*/
.change_text_color:hover{
    color: #0f74a8;
    text-decoration: underline;
}

</style>
